<template>
  <div class="pagination-wrapper">
    <div v-if="configurablePageSize" class="item-count">
      <span>Displaying</span>
      <SelectDropDownV2
        v-model="newPageSize"
        :options="pageSizeOptionsForDropdown"
        :enableSearch="false"
        popoverSize="auto"
        class="page-size-select"
        :customStyle="{ backgroundColor: 'var(--white)', padding: '5px 10px' }"
      />
      <span>per page</span>
    </div>
    <div class="pagination" v-if="totalCount && totalPages > 1" :class="{'is-loading': loading}">
      <ul>
        <li v-if="isPrevEnabled && totalPages > 10">
          <a class="page-link page-next-prev paginationImg" @click="() => currentSelectedPage = 1" :class="{'disabled': !isPrevEnabled}">
            <img src="../resources/images/Paginator_backward.svg" />
          </a>
        </li>
        <li>
          <a class="page-link page-next-prev" @click="() => isPrevEnabled && currentSelectedPage--" :class="{'disabled': !isPrevEnabled}">
            <VIcon name="chevron-left-line"></VIcon>
          </a>
        </li>
      </ul>

      <ul v-for="index in totalPages" :key="index">
        <li v-if="Math.abs(currentSelectedPage - index) < 3" :class="{active: index === currentSelectedPage}">
          <a class="page-link" @click="index !== currentSelectedPage && (currentSelectedPage = index)">{{ index }}</a>
        </li>
        <li v-else-if="index < 4 || totalPages - index < 3" class="dots">
          <span>.</span>
        </li>
      </ul>

      <ul>
        <li style="margin-left: 0px;">
          <a class="page-link page-next-prev" @click="() => isNextEnabled && currentSelectedPage++" :class="{'disabled': !isNextEnabled}">
            <VIcon name="chevron-right-line"></VIcon>
          </a>
        </li>
        <li v-if="isNextEnabled && totalPages > 10" style="margin-left: 0px;">
          <a class="page-link page-next-prev paginationImg" @click="() => currentSelectedPage = totalPages" :class="{'disabled': !isNextEnabled}">
            <img src="../resources/images/Paginator_forward.svg" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import SelectDropDownV2 from './SelectDropDownV2.vue';

export default {
  components: { SelectDropDownV2 },
  data() {
    return {
      pageSizeOptions: [5, 10, 20, 25, 50]
    }
  },
  props: {
    totalCount: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      default: 5
    },
    currentPage: {
      type: Number,
      default: 1
    },
    navBarLength: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    configurablePageSize: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  computed: {
    currentSelectedPage: {
      set(value) {
        if (this.loading) return;
        this.$emit('change', { page: value, pageSize: this.newPageSize });
      },
      get() {
        return this.currentPage;
      }
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.newPageSize);
    },
    isPrevEnabled() {
      return !(this.currentSelectedPage <= 1);
    },
    isNextEnabled() {
      return this.currentSelectedPage < this.totalPages;
    },
    newPageSize: {
      set(value) {
        if (this.loading) return;
        this.$emit('change', { page: 1, pageSize: value });
      },
      get() {
        return this.pageSize;
      }
    },
    pageSizeOptionsForDropdown() {
      return this.pageSizeOptions.map(i => ({ title: String(i), value: i }));
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  width: 100%;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  .item-count {
    display: flex;
    gap: 5px;
    align-items: center;
    font-size: 14px;
    color: var(--gray-04);
    span {
      white-space: nowrap;
    }
    .page-size-select {
      min-width: 70px;
      min-height: 30px;
    }
  }
  .pagination {
    li a{
      padding: 5px 8px;
      height: 25px;
      display: block;
      color: var(--black-01);
      &.disabled {
        opacity: 0.4;
        pointer-events: none;
      }
    }
    ul:last-child {
      li a{ padding-right: 0px;}
    }
    ul:first-child {
      li a {
        padding-right: 0px;
      }
    }
    .active {
      background: var(--purple);
      a {
        color: #ffffff;
      }
    }
    &.is-loading {
      opacity: 0.4;
      pointer-events: none;
      transition: opacity 0.2s ease;
    }
  }
}

.pagination ul {
  padding: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  display: inline-block;
}

.pagination ul li {
  display: inline-block;
  margin-left: 7px;
  -webkit-border-radius: 5px;
  border-radius: 50%;
  line-height: 1;
  font-size: 15px;
  vertical-align: middle;
}
.paginationImg{
  width: 24px;
  height: 24px;
}
@media only screen and (max-width: 760px){
  .pagination{
    text-align: center;
    width: 100%;
  }
}
</style>